<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="rack" title="A Note on Sources">
<p class="fmh"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><a href="#/text/9780253044792_Contents#source">A NOTE ON SOURCES</a></span></p>
<p class="noindent"><span class="dropcap">S</span><span class="small">ECONDARY SOURCES ARE REFERENCED IN THE TEXT USING</span> parenthetical citations. To make it easier for the reader to identify and locate a wide range of primary sources, from archival references to interviews, online content, and newspapers, I have chosen to cite primary sources using endnotes. In the case of archival sources, the citation includes the name of the archive, the name of the documentary fond, the number of the file, and the specific page numbers in the file. In some archives (e.g., those of the National Institute of Patrimony), some files were not included in an archival fond; sometimes, these files were also composed of a series of disparate documents that did not have continuous page numbers. In those cases, I identify the source by the archive, the file number, the title of the document, and the specific pages within the document. Excerpts from interviews or fieldwork conversations are cited by the date, the place, and the pseudonym I gave the interviewee. Newspaper articles retrieved from printed newspapers are cited by the name of the newspaper, the date, the original title of the article, and (if identifiable) the journalists’ names.</p>
<p class="h3a">Newspapers and Periodicals Cited as Primary Sources</p>
<p class="noindent"><i>Arhitectura</i> (1952–89)</p>
<p class="noindent"><i>România Liberă</i> (1990–2015)</p>
<p class="noindent"><i>Adevărul</i> (1990–2015)</p>
<p class="noindent"><i>Revista 22</i> (1990–98, 2000–2015)<span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044792_Sources.vue?2b19f328